import { createContext } from 'react';

export type ErrorBoundaryContextType = {
  didCatch: boolean;
  // oxlint-disable-next-line typescript/no-explicit-any
  error: any;
};

export const ErrorBoundaryContext =
  createContext<ErrorBoundaryContextType | null>(null);
